import React from 'react';
import {
  CalendarDays,
  ClipboardList,
  FileBarChart,
  FileCheck2,
  FileText,
  Gavel,
  MessageSquareText,
  Paperclip,
  Receipt,
  ScrollText,
  UserRound,
  Users,
  Video,
} from 'lucide-react';

const PALETTE = {
  navy: '#0F2742',
  green: '#1F8A70',
  gold: '#C8A45C',
  softBg: '#F7F9FB',
  border: '#DCE7E3',
  text: '#334155',
};

const MENU_ITEMS = [
  { id: 'overview', label: 'نظرة عامة', icon: FileText },
  { id: 'parties', label: 'الأطراف', icon: Users },
  { id: 'hearings', label: 'الجلسات', icon: CalendarDays },
  { id: 'memorandums', label: 'المذكرات', icon: ScrollText },
  { id: 'requests', label: 'الطلبات المقدمة', icon: ClipboardList },
  { id: 'reports', label: 'التقارير', icon: FileBarChart },
  { id: 'sessionRecords', label: 'الخطابات الرسمية', icon: FileCheck2 },
  { id: 'authorityDecisions', label: 'القرارات الصادرة', icon: Gavel },
  { id: 'attachments', label: 'المرفقات', icon: Paperclip },
  { id: 'tickets', label: 'تذاكر العميل', icon: MessageSquareText },
  { id: 'lawyer', label: 'المحامي المكلف', icon: UserRound },
  { id: 'fees', label: 'الرسوم والمدفوعات', icon: Receipt },
  { id: 'videoMeeting', label: 'حجز اجتماع عن بعد', icon: Video },
];

const CaseSidebar = ({ activeSection, onSectionChange }) => {
  return (
    <aside
      style={{
        position: 'sticky',
        top: 24,
        alignSelf: 'start',
        background: 'rgba(255,255,255,0.95)',
        border: `1px solid ${PALETTE.border}`,
        borderRadius: 26,
        padding: 20,
        boxShadow: '0 18px 42px rgba(15, 39, 66, 0.07)',
      }}
    >
      <div style={{ display: 'grid', gap: 10 }}>
        {MENU_ITEMS.map(({ id, label, icon: Icon }) => {
          const isActive = activeSection === id;

          return (
            <button
              key={id}
              type="button"
              onClick={() => onSectionChange(id)}
              style={{
                border: isActive ? 'none' : `1px solid ${PALETTE.border}`,
                borderRadius: 18,
                padding: '12px 14px',
                background: isActive
                  ? `linear-gradient(135deg, ${PALETTE.navy}, #17395E)`
                  : '#FFFFFF',
                color: isActive ? '#FFFFFF' : PALETTE.text,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 12,
                textAlign: 'right',
                cursor: 'pointer',
                transition: 'all 0.22s ease',
                boxShadow: isActive
                  ? '0 16px 30px rgba(15, 39, 66, 0.16)'
                  : '0 8px 16px rgba(15, 39, 66, 0.04)',
                fontWeight: 800,
                fontSize: 14,
              }}
            >
              <span style={{ flex: 1 }}>{label}</span>
              <span
                style={{
                  width: 36,
                  height: 36,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 12,
                  background: isActive ? 'rgba(255,255,255,0.14)' : PALETTE.softBg,
                  color: isActive ? PALETTE.gold : PALETTE.green,
                  flexShrink: 0,
                }}
              >
                <Icon size={18} />
              </span>
            </button>
          );
        })}
      </div>
    </aside>
  );
};

export default CaseSidebar;
